export const NO_AVAILABLE_PRODUCTS =
  "Unfortunately, there are no available products for the filters you've selected. Try reducing your criteria by removing some of the above applied filters."
